import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { i18n } from '../i18n'
import { createPinia } from 'pinia'
import VBenefitsSlider from '../components/VBenefitsSlider.vue'
import VAboutUsSlider from '../components/VAboutUsSlider.vue'
import VAboutUsSliderMobile from '../components/VAboutUsSliderMobile.vue'
import VReferenceSlider from '../components/VReferenceSlider.vue'
import VPhotoSlider from '../components/VPhotoSlider.vue'
import VHomepageSideVideo from '../components/VHomepageSideVideo.vue'
import { app } from '../app'

const pinia = createPinia()

createApp({
  components: {
    VBenefitsSlider,
    VAboutUsSlider,
    VAboutUsSliderMobile,
    VReferenceSlider,
    VPhotoSlider,
    VHomepageSideVideo
  },
  extends: app
})
  .use(vuetify)
  .use(i18n)
  .use(pinia)
  .mount('#app')
